import React, { useState, useEffect } from 'react';
// СЛЕД КАТО СВАЛИШ ДВЕТЕ КАРТИНКИ, ГИ ИМПОРТИРАЙ ТУК:
// import sandBg from './assets/sand-only.jpg'; // Твоята Image 8 (само пясък)
// import waveBg from './assets/sand-with-wave.jpg'; // Твоята Image 7 (пясък + вълна)

const DiscoverVarnaHook = ({ onGameStart }) => {
    const [wavePhase, setWavePhase] = useState('idle'); // 'idle' | 'rising' | 'done'

    useEffect(() => {
        // Зареждаме красив шрифт за текста на пясъка
        const link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css2?family=Caveat:wght@700&display=swap';
        link.rel = 'stylesheet';
        document.head.appendChild(link);
    }, []);

    const handleStartWave = () => {
        if (wavePhase !== 'idle') return;
        setWavePhase('rising');

        // Цялата анимация трае 4 секунди. Накрая фиксираме финалния екран.
        setTimeout(() => {
            setWavePhase('done');
        }, 4000);
    };

    // Линкове към генерираните картинки (замени ги с локалните си импорти след сваляне)
    const imgSandOnly = "./assets/sand.jpg";
    const imgSandWithWave = "./assets/varna-beach.jpg";

    return (
        <div style={{
            position: 'relative',
            width: '100%',
            height: '100vh',
            maxWidth: '500px',
            margin: '0 auto',
            overflow: 'hidden',
            backgroundColor: '#bc9c74',
            fontFamily: 'sans-serif',
            userSelect: 'none',
            WebkitUserSelect: 'none'
        }}>

            <style>{`
        @keyframes waveRiseUp {
          0% { bottom: -20%; }
          100% { bottom: 120%; }
        }
        @keyframes revealWaterUnderWave {
          0% { clip-path: inset(100% 0% 0% 0%); }
          100% { clip-path: inset(0% 0% 0% 0%); }
        }
        @keyframes pulseShell {
          0% { transform: scale(1); opacity: 0.8; }
          50% { transform: scale(1.12); opacity: 1; }
          100% { transform: scale(1); opacity: 0.8; }
        }
        @keyframes fadeInUI {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>

            {/* СЛОЙ 1: НАЧАЛЕН ФОН - САМО ПЯСЪК (Винаги най-отдолу) */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundImage: `url(${imgSandOnly})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                zIndex: 1
            }} />

            {/* СЛОЙ 2: КРАЕН ФОН - ПЯСЪК С ВЪЛНА (Разкрива се плавно отдолу нагоре чрез clip-path) */}
            {(wavePhase === 'rising' || wavePhase === 'done') && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${imgSandWithWave})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    zIndex: 2,
                    // Сортиране на анимацията: отнема точно 4 секунди, синхронизирано с вълната
                    animation: wavePhase === 'rising' ? 'revealWaterUnderWave 4s ease-in-out forwards' : 'none',
                    clipPath: wavePhase === 'done' ? 'inset(0% 0% 0% 0%)' : 'inset(100% 0% 0% 0%)'
                }} />
            )}

            {/* ИНТЕРФЕЙС ФАЗА 1: НАДПИС И МИДА ВЪРХУ ПЯСЪКА */}
            {wavePhase !== 'done' && (
                <div style={{
                    position: 'absolute',
                    top: '30%',
                    width: '100%',
                    textAlign: 'center',
                    zIndex: 3,
                    transition: 'opacity 0.5s ease',
                    opacity: wavePhase === 'rising' ? 0 : 1
                }}>
                    <h1 style={{
                        fontFamily: "'Caveat', cursive",
                        fontSize: '54px',
                        color: 'rgba(60, 40, 25, 0.75)',
                        margin: 0,
                        textShadow: '1px 1px 1px rgba(255,255,255,0.4)'
                    }}>
                    </h1>

                    <div
                        onClick={handleStartWave}
                        style={{
                            fontSize: '65px',
                            marginTop: '50px',
                            cursor: 'pointer',
                            animation: 'pulseShell 2.5s infinite ease-in-out',
                            filter: 'drop-shadow(0 6px 8px rgba(0,0,0,0.3))',
                            WebkitTapHighlightColor: 'transparent'
                        }}
                    >
                        🐚
                    </div>
                    <p style={{
                        color: '#fff',
                        fontSize: '11px',
                        letterSpacing: '2px',
                        marginTop: '15px',
                        textShadow: '1px 1px 3px rgba(0,0,0,0.6)'
                    }}>
                        ДОКОСНИ МИДАТА ЗА СТАРТ
                    </p>
                </div>
            )}

            {/* ИНТЕРФЕЙС ФАЗА 2: КАРТАТА СЪС ЗАГАДКАТА (Появява се чак накрая) */}
            {wavePhase === 'done' && (
                <div style={{
                    position: 'absolute',
                    top: '20%',
                    left: '7.5%',
                    width: '85%',
                    zIndex: 10,
                    padding: '30px 20px',
                    borderRadius: '24px',
                    background: 'rgba(255, 255, 255, 0.15)',
                    backdropFilter: 'blur(15px)',
                    WebkitBackdropFilter: 'blur(15px)',
                    border: '1px solid rgba(255, 255, 255, 0.25)',
                    textAlign: 'center',
                    boxShadow: '0 15px 35px rgba(0,0,0,0.2)',
                    animation: 'fadeInUI 1s cubic-bezier(0.175, 0.885, 0.32, 1.1) forwards'
                }}>
                    <h2 style={{ color: '#004370', fontSize: '26px', marginBottom: '12px', fontWeight: 'bold' }}>
                        Морската столица
                    </h2>
                    <p style={{ color: '#002642', fontSize: '15px', lineHeight: '1.6', marginBottom: '30px', fontWeight: '500' }}>
                        Вълната отми пясъка и разкри пътя към първата тайна на Варна. Готов ли си?
                    </p>
                    <button
                        onClick={onGameStart}
                        style={{
                            padding: '15px 40px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: 'white',
                            background: 'linear-gradient(135deg, #0093e9, #80d0c7)',
                            border: 'none',
                            borderRadius: '50px',
                            boxShadow: '0 6px 20px rgba(0, 147, 233, 0.4)',
                            cursor: 'pointer'
                        }}
                    >
                        Гмурни се
                    </button>
                </div>
            )}

            {/* ДИГИТАЛНАТА ВЪЛНА (ИЗДИГА СЕ БАВНО НАГОРЕ И СЛУЖИ ЗА ПРЕХОДЕН РЪБ) */}
            {wavePhase === 'rising' && (
                <div style={{
                    position: 'absolute',
                    left: '-10%',
                    width: '120%',
                    height: '25%',
                    zIndex: 4,
                    // Бяла 3D пяна, която маскира линията на срязване
                    background: 'linear-gradient(to top, transparent 0%, rgba(255,255,255,0.95) 50%, rgba(255,255,255,1) 70%, transparent 100%)',
                    boxShadow: '0 15px 30px rgba(140,215,255,0.4), 0 -15px 30px rgba(255,255,255,0.8)',
                    borderRadius: '50% 50% 0 0',
                    animation: 'waveRiseUp 4s ease-in-out forwards',
                    filter: 'blur(1px)'
                }}>
                    {/* Силна светлинна линия на самата пяна */}
                    <div style={{
                        position: 'absolute',
                        bottom: '30%',
                        width: '100%',
                        height: '6px',
                        background: 'white',
                        boxShadow: '0 0 20px 8px white'
                    }} />
                </div>
            )}

        </div>
    );
};

export default DiscoverVarnaHook;